
const NicheTechnologies = () => {
  const technologies = [
    {
      title: "Smart Scale Inhibitor Technology",
      description: "Revolutionary scale inhibitor with real-time monitoring capabilities and adaptive dosing based on field conditions",
      innovation: "IoT-enabled chemical delivery system with predictive analytics",
      benefits: ["95% scale prevention efficiency", "50% reduction in chemical usage", "Real-time performance monitoring"],
      image: "https://public.readdy.ai/ai/img_res/f169dbe87a5fa3737b7b7e76e1806d47.jpg"
    },
    {
      title: "Nano-Enhanced Acid Systems",
      description: "Next-generation acid formulations incorporating nanotechnology for enhanced penetration and reaction control",
      innovation: "Nanoparticle-stabilized acid systems with controlled release mechanisms",
      benefits: ["300% deeper penetration", "Extended reaction time", "Minimal formation damage"],
      image: "https://readdy.ai/api/search-image?query=Nano-enhanced%20acid%20systems%20with%20Golden%20Black%20logo%2C%20advanced%20nanotechnology%20laboratory%20with%20controlled%20release%20mechanisms%20for%20enhanced%20oil%20recovery&width=500&height=300&seq=nano-acid&orientation=landscape"
    },
    {
      title: "Bio-Inspired Corrosion Inhibitors",
      description: "Environmentally friendly corrosion inhibitors based on natural compounds with superior performance",
      innovation: "Biomimetic molecular design with enhanced metal surface affinity",
      benefits: ["90% corrosion reduction", "Biodegradable formulation", "Extended equipment life"],
      image: "https://readdy.ai/api/search-image?query=Bio-inspired%20corrosion%20inhibitors%20with%20Golden%20Black%20branding%2C%20green%20chemistry%20laboratory%20developing%20environmentally%20friendly%20metal%20protection%20solutions&width=500&height=300&seq=bio-inhibitor&orientation=landscape"
    },
    {
      title: "Intelligent Demulsification System",
      description: "AI-powered demulsifier selection and optimization system for complex emulsion challenges",
      innovation: "Machine learning algorithms for optimal chemical selection and dosing",
      benefits: ["98% separation efficiency", "Automated optimization", "Reduced operational costs"],
      image: "https://readdy.ai/api/search-image?query=Intelligent%20demulsification%20system%20with%20Golden%20Black%20technology%2C%20AI-powered%20chemical%20optimization%20with%20automated%20separation%20control%20systems&width=500&height=300&seq=intelligent-demulsifier&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Niche Technologies & Innovations
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Black leads the industry with breakthrough technologies that redefine 
            chemical solutions for oil and gas operations, setting new standards for performance and sustainability.
          </p>
        </div>

        <div className="space-y-16">
          {technologies.map((tech, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className="lg:w-1/2">
                <img 
                  src={tech.image}
                  alt={tech.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              
              <div className="lg:w-1/2">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{tech.title}</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">{tech.description}</p>
                
                <div className="bg-teal-50 rounded-lg p-6 mb-6">
                  <h4 className="font-semibold text-teal-800 mb-2 flex items-center">
                    <i className="ri-lightbulb-line mr-2"></i>
                    Innovation Highlight:
                  </h4>
                  <p className="text-teal-700">{tech.innovation}</p>
                </div>
                
                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900">Key Benefits:</h4>
                  <div className="space-y-2">
                    {tech.benefits.map((benefit, benefitIndex) => (
                      <div key={benefitIndex} className="flex items-center">
                        <i className="ri-check-line text-teal-600 mr-3"></i>
                        <span className="text-gray-700">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gray-50 rounded-xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Innovation Partnership Program
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Join Golden Black's innovation ecosystem. We collaborate with leading operators 
              to develop next-generation technologies that address tomorrow's challenges today.
            </p>
            <a 
              href="/consultation" 
              className="bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Explore Partnership Opportunities
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NicheTechnologies;
